module.exports = __webpack_public_path__ + "img/WhatsApp-1.dc3643d0.jpeg";